import { StorageLogger } from './localStoragePlugin'
import { LoggerConfig } from './loggerConfig'

/**
 * Vue Component Logger Plugin
 * Provides global logging functionality for Vue components
 */
export default {
    /**
     * Install plugin to Vue app
     * @param {App} app - Vue application instance
     */
    install(app) {
        // Clear previous logs on app initialization
        StorageLogger.clear()

        /**
         * Global $log method for components
         * Usage: this.$log('message', payload)
         * @param {string} message - Log message
         * @param {any} payload - Additional data to log
         */
        app.config.globalProperties.$log = function (message, payload) {
            const component = getComponentName(this)
            StorageLogger.logCustom(message, payload, component)
        }

        // Provide StorageLogger as $logger
        app.config.globalProperties.$logger = StorageLogger

        // Provide logger for composition API
        app.provide('log', StorageLogger)
    },

    /**
     * Check if logger is enabled
     * @returns {boolean}
     */
    isEnabled() {
        return LoggerConfig.enabled()
    }
}

/**
 * Extract component name from Vue component instance
 * @param {ComponentPublicInstance} instance - Vue component instance
 * @returns {string} Component name
 */
function getComponentName(instance) {
    // Try to get name from options
    if (instance?.$options?.name) {
        return instance.$options.name
    }

    // Try to extract filename from __file
    if (instance?.$options?.__file) {
        return instance.$options.__file.split('/').pop()
    }

    return 'UnknownComponent'
}
